import { Injectable } from "@angular/core";
import { StorageConfig } from "@ebootis/utilities";

@Injectable({
	providedIn: 'root'
})
export class StorageConfigService implements StorageConfig {
	private m_prefix: string;
	constructor() {
	}
	getPrefix() {
		return this.m_prefix;
	}
	setPrefix(p_prefix: string) {
		this.m_prefix = p_prefix;
	}
}